"use strict";

const OrgSwitcherPort = {
  add: (app) => {
    if (app.ports.enableOrgSwitcherShortcutPort) {
      app.ports.enableOrgSwitcherShortcutPort.subscribe(() => {
        document.addEventListener("keydown", function (e) {
          if (
            (e.metaKey || e.ctrlKey) &&
            e.shiftKey &&
            (e.key === "o" || e.key === "O")
          ) {
            e.preventDefault();
            app.ports.orgSwitcherTriggeredPort.send(null);
          }
        });
      });
    }
  },
};

module.exports = OrgSwitcherPort;
